import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/site";

export default function WhatsAppButton() {
  return (
    <a
      href={waLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat With HAQILA"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-3"
    >
      <span className="hidden sm:block max-w-0 overflow-hidden group-hover:max-w-[180px] transition-[max-width] duration-500 ease-out">
        <span className="block whitespace-nowrap bg-charcoal text-offwhite text-xs font-semibold tracking-wide px-4 py-2.5 border border-white/10">
          Chat With HAQILA
        </span>
      </span>
      <span className="relative w-14 h-14">
        <span className="absolute inset-0 bg-[#25D366] animate-pulse-ring" />
        <span className="relative w-14 h-14 bg-[#25D366] hover:bg-[#1fb857] flex items-center justify-center transition-colors duration-300 shadow-lg shadow-black/25">
          <MessageCircle className="w-6 h-6 text-white" fill="white" />
        </span>
      </span>
    </a>
  );
}
